import { TOGGLE_SIDEBAR } from '../constants/constants';

export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR,
});